/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable no-await-in-loop */
import { Dispatch } from 'react'
import axios, { CancelTokenSource } from 'axios'
import moment from 'moment'
import qs from 'qs'
// eslint-disable-next-line
import jwt_decode from 'jwt-decode'
import * as Msal from 'msal'

import OrganizationEntity, {
  FormatedOrganization,
} from 'utils/__interfaces/Administrations/Organizations/OrganizationEntity'
import AllRolesEntity from 'utils/__interfaces/Roles/AllRolesEntity'
import CollapseDto from 'utils/__interfaces/Common/Collapse'
import {
  DEFAULT_USERINFOS,
  StatusOptions,
} from 'utils/__consts/Administration/User'
import { SERVICE_AUTRE_VALUE } from 'utils/__consts/Common/Service'
import {
  ContactPreference,
  UserEntity,
} from 'utils/__interfaces/Administrations/Users/UserEntity'
import UsersNormalizer from 'normalizer/UsersNormaliser'
import ContractEntity from 'utils/__interfaces/Perimeter/ContractEntity'

import { InitialStateType } from 'store/state'
import { APP_ACTIONS, ActionTypes } from 'store/actions'
import ROUTES from 'utils/ROUTES'
import {
  getAdminUserSymbol,
  getStatusValue,
} from 'utils/Administrations/Users/user-utils'
import { getDomainMail } from 'utils/Common/ts-utils'
import flatFilter from 'utils/Filters/filter-utils'
import { TIME_OUT_TABLE } from 'utils/__consts/Common/Table'
import isCancel from 'utils/Common/api-utils'
import {
  getFormatedOrganisations,
  searchOrganizationByIds,
} from './organization-services'
import { getAllRoles } from './roles-services'
import { getMemberData, getNextPage, isLastPage } from './hydra-services'
import { parseDate } from '../utils/Common/date-utils'

const XlsxTemplate = require('xlsx-template')

const msalConfig = {
  auth: {
    clientId: `${process.env.REACT_APP_AZURE_AD_CLIENT_ID}`,
    authority: `${process.env.REACT_APP_AZURE_AD_URL_AUTH}`,
    redirectUri: `${process.env.REACT_APP_AZURE_AD_REDIRECT_URI}`,
  },
}

const msalInstance = new Msal.UserAgentApplication(msalConfig)

let cancelToken: CancelTokenSource

export interface DecodedToken {
  username: string
  // eslint-disable-next-line camelcase
  user_id: string
  organizations: OrganizationToken[]
  roles: any[]
  // eslint-disable-next-line camelcase
  first_name: string
  access_demands: number
  access_docs: number
  isInternal: number
  id_contact_wdh: string
  service: string
  is_super_admin_tech: number
}

export interface UserData {
  username: string
  userId: string
  organizations: string[]
  token?: string
  roleNames: string[]
  firstname: string
  accessDemands: boolean
  accessDocs: boolean
  isInternal: boolean
  isSuperAdminTech: boolean
  service: string
  idContactWdh: string
}

interface OrganizationToken {
  id: string
}

const labelsToApiFields: { [key: string]: string } = {
  Nom: 'lastname',
  Prénom: 'firstname',
  Identifiant: 'username',
  'Éts/Ct de rattachement': 'company',
  'Créé le': 'createdAt',
  'Dernière connexion': 'lastConnexionDate',
  Statut: 'state',
}

export async function getUserInfo(userId: string): Promise<UserEntity> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/users/${userId}`
  let user: UserEntity = DEFAULT_USERINFOS

  try {
    const resp = await axios({
      method: 'GET',
      url,
    })
    if (resp?.data) {
      const result = UsersNormalizer.normalizeSingle([resp.data])

      if (result.length > 0) {
        const [item] = result
        user = item
      }
    }
  } catch (err) {
    throw new Error(
      `Erreur lors de l'appel de l'api getUserInfo avec l'url : '/users/${userId}'`
    )
  }

  return user
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function createUser(user: any): Promise<string> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/users`

  let status = ''

  try {
    const resp = await axios({
      method: 'POST',
      url,
      data: {
        username: user.username,
        type: user.type,
        email: user.email,
        firstname: user.firstname,
        lastname: user.lastname,
        service: user.service,
        officePhone: user.officePhone,
        mobilePhone: user.mobilePhone,
        compagny: user.compagny,
        compagnyId: user.compagnyId,
        preferences: user.preferences,
        roles: user.roles,
        accessDemands: user.accessDemands,
        accessDocs: user.accessDocs,
        isSuperAdminTech: user.isSuperAdminTech,
      },
    })

    if (resp?.data['@id'] !== undefined) {
      status = resp?.data['@id']
    }
  } catch (err) {
    if (err?.response?.data?.violations) {
      throw new Error(err.response.data.violations[0].message)
    }
    throw new Error("Erreur lors de la création de l'utilisateur")
  }

  return status
}

export async function updateUserContract(
  contract: string,
  contratId: string,
  userId: string
): Promise<number> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/users/${userId}`

  let status = 400

  try {
    const resp = await axios({
      method: 'PATCH',
      url,
      data: {
        company: contract,
        contratId,
      },
    })
    status = resp?.status
  } catch (err) {
    throw new Error(`Erreur lors de l'exécution de l'api updateUserContract`)
  }

  return status
}

export async function patchUser(user: UserEntity): Promise<number> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/users/${user.id}`
  let status = 400
  const data = { ...user }

  if (!data.service || data.service === SERVICE_AUTRE_VALUE) {
    delete data.service
  }
  try {
    const resp = await axios({
      method: 'PATCH',
      url,
      data,
    })
    status = resp?.status
  } catch (err) {
    if (err?.response?.data?.violations) {
      throw new Error(err.response.data.violations[0].message)
    }
    throw new Error("Une erreur est survenue lors de l'enregistrement")
  }

  return status
}

export function prepareDataForPatch(
  user: UserEntity,
  userId: string,
  roleUris: string[],
  pref: ContactPreference
): any {
  const userBody: any = user
  delete userBody.createdAt
  delete userBody.lastConnexionDate
  delete userBody.passwordExpirationDate
  delete userBody.organizations
  delete userBody.contratId
  delete userBody.contrat
  userBody.id = userId
  userBody.preferences = JSON.stringify(pref)
  userBody.roles = roleUris

  return userBody
}

export async function getUserIdByUserName(username: string): Promise<string> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/users/username=${username}`
  try {
    const resp = await axios({
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      url,
    })
    if (resp?.data) {
      const result = UsersNormalizer.normalize([resp.data])

      if (result.length > 0) {
        const [item] = result
        return item.id
      }
    }
  } catch (err) {
    console.error('cannot get UserId')
  }

  return ''
}

export async function getUserInfoFromAD(UpnId: string): Promise<any> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/users/aad/${UpnId}`

  let userUpn
  try {
    const resp = await axios({
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      url,
    })
    userUpn = resp?.data
  } catch (err) {
    return null
  }
  return userUpn
}

export function prepareFinalDtoData(
  allDto: CollapseDto[] | undefined,
  selectedList: string[]
): CollapseDto[] {
  const result: CollapseDto[] = []
  if (allDto)
    allDto.forEach((dto) => {
      if (selectedList.includes(dto.id)) result.push(dto)
      if (dto.children !== undefined) {
        dto.children.forEach((child) => {
          if (child.type === 'collapse') {
            if (selectedList.includes(child.id)) result.push(child)
            prepareFinalDtoData(dto.children, selectedList)
            const recResult = prepareFinalDtoData(dto.children, selectedList)
            if (recResult) {
              recResult.forEach((elem) => {
                result.push(elem)
              })
            }
          }
        })
      }
    })
  return result.filter((v, i, a) => a.findIndex((xt) => xt.id === v.id) === i)
}
/**
 * When selecting  an organization get the ids of
 * parent and children to hide checkbox
 * @param allDto
 * @param selectedList
 */
export function getCollapseIdsToHideCheckbox(
  allDto: CollapseDto[] | undefined,
  selectedList: string[]
): string[] {
  const result: string[] = []
  if (allDto)
    allDto.forEach((dto) => {
      if (dto.parentId && selectedList.includes(dto.id))
        result.push(dto.parentId)
      if (dto.children !== undefined) {
        dto.children.forEach((child) => {
          if (child.type === 'collapse') {
            if (child.parentId && selectedList.includes(child.parentId)) {
              result.push(child.id)
            }
            const recResult = getCollapseIdsToHideCheckbox(
              dto.children,
              selectedList
            )
            if (recResult)
              recResult.forEach((elem) => {
                result.push(elem)
              })
          }
        })
      }
    })
  return result.filter(function (item, pos) {
    return result.indexOf(item) === pos
  })
}

export async function patchUserForPerimetreOrganisations(
  organizations: FormatedOrganization[],
  userId: string,
  history?: any
): Promise<number> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/users/${userId}`

  let status = 400

  try {
    const resp = await axios({
      method: 'PATCH',
      url,
      data: {
        organizations,
      },
    })
    status = resp?.status
  } catch (err) {
    if (history) history.push(ROUTES.TechnicalError)
    console.error(err)
  }
  return status
}

export async function deleteOrganisationsForUser(
  organizations: FormatedOrganization[],
  userId: string,
  history?: any
): Promise<string[]> {
  return Promise.all(
    organizations.map(async (element) => {
      const appId = element.application.split('/')[2]
      const url = `${process.env.REACT_APP_BASE_API_URL}/asso_users_organisations/organisationId=${element.organisationId};application=${appId};user=${userId}`

      try {
        const res = await axios({
          method: 'DELETE',
          url,
          headers: {
            'content-type': 'application/merge-patch+json',
          },
        })
        if (res?.status === 204) return element.organisationId
        return ''
      } catch (error) {
        if (history) history.push(ROUTES.TechnicalError)
        console.error(error)
        return ''
      }
    })
  )
}

export async function putStatutOrganisationDelete(
  statut: string,
  organizationId: string,
  history: any
): Promise<any> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/asso_users_organisations/${organizationId}/delete`

  try {
    const resp = await axios({
      method: 'PUT',
      url,
      data: {
        statut,
      },
    })
    return resp?.data
  } catch (err) {
    history.push(ROUTES.TechnicalError)
    throw new Error("Erreur lors de l'appel api : delete assoUserOrganisations")
  }
}

export async function patchUserForActivation(
  state: string,
  userId: string,
  history?: any
): Promise<number> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/users/${userId}`

  let status = 400

  try {
    const resp = await axios({
      method: 'PATCH',
      url,
      data: {
        state,
        userId,
      },
    })
    status = resp?.status
  } catch (err) {
    if (history) history.push(ROUTES.TechnicalError)
    console.error(err)
  }
  return status
}

// GESTION DES UTILISATEUR

// get all the users using the api
export async function getAllUsers(
  perPage: any,
  page: number,
  organisation: OrganizationEntity[] = [],
  contracts: ContractEntity[] = [],
  sortTable: any,
  filters: { [key: string]: any | any[] }
): Promise<{ results: UserEntity[]; pageCount: number; isTimeOut: boolean }> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/users?perPage=${perPage}&page=${page}`

  let listOfusers: UserEntity[] = []
  const params = new URLSearchParams()

  organisation.forEach((org) => {
    params.append('idOrganisation[]', org.id)
  })
  contracts.forEach((contract) => {
    params.append('contratId[]', contract.id)
  })
  if (sortTable) {
    Object.keys(sortTable).forEach((key: string) => {
      params.append(`order[${labelsToApiFields[key]}]`, sortTable[key])
    })
  }

  flatFilter(params, filters)

  if (cancelToken !== undefined) {
    cancelToken.cancel('Operation canceled due to new request.')
  }

  cancelToken = axios.CancelToken.source()

  try {
    const resp = await axios({
      method: 'GET',
      url,
      params,
      cancelToken: cancelToken.token,
      timeout: TIME_OUT_TABLE,
    })
    if (resp?.data) {
      // Result Normalization
      listOfusers = UsersNormalizer.normalize(getMemberData(resp.data))
      const totalItems = parseInt(resp.data['hydra:totalItems'], 10)
      return {
        results: [...listOfusers],
        pageCount: Math.ceil(totalItems / perPage),
        isTimeOut: false,
      }
    }
  } catch (err) {
    if (err?.code === 'ECONNABORTED') {
      return Promise.resolve({
        pageCount: 0,
        results: [],
        totalItems: 0,
        isTimeOut: true,
      })
    }

    if (isCancel(err)) {
      return Promise.resolve({ pageCount: 0, results: err, isTimeOut: false })
    }
    throw new Error(`Erreur : ${err}`)
  }
  return Promise.resolve({ pageCount: 0, results: [], isTimeOut: false })
}

// get all the users using the api
export async function getAllUsersSuperAdmin(
  perPage: any,
  page: number,
  organisation: OrganizationEntity[] = [],
  contracts: { id: string }[] = [],
  sortTable: any,
  filters: { [key: string]: any | any[] }
): Promise<{
  results: UserEntity[]
  pageCount: number
  totalItems: number
  isTimeOut: boolean
}> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/users?perPage=${perPage}&page=${page}`

  let listOfusers: UserEntity[] = []
  const params = new URLSearchParams()

  organisation.forEach((org) => {
    params.append('idOrganisation[]', org.id)
  })
  contracts.forEach((contract) => {
    params.append('contratId[]', contract.id)
  })
  if (sortTable) {
    Object.keys(sortTable).forEach((key: string) => {
      params.append(`order[${labelsToApiFields[key]}]`, sortTable[key])
    })
  }

  flatFilter(params, filters)

  if (cancelToken !== undefined) {
    cancelToken.cancel('Operation canceled due to new request.')
  }

  cancelToken = axios.CancelToken.source()

  try {
    const resp = await axios({
      method: 'GET',
      url,
      params,
      cancelToken: cancelToken.token,
    })
    if (resp?.data) {
      // Result Normalization
      listOfusers = UsersNormalizer.normalize(getMemberData(resp.data))
      const totalItems = parseInt(resp.data['hydra:totalItems'], 10)
      return {
        results: [...listOfusers],
        pageCount: Math.ceil(totalItems / perPage),
        totalItems,
        isTimeOut: false,
      }
    }
  } catch (err) {
    if (err?.code === 'ECONNABORTED') {
      return Promise.resolve({
        pageCount: 0,
        results: [],
        totalItems: 0,
        isTimeOut: true,
      })
    }
    if (isCancel(err)) {
      return Promise.resolve({
        pageCount: 0,
        results: err,
        totalItems: 0,
        isTimeOut: false,
      })
    }
    throw new Error(`Erreur : ${err}`)
  }
  return Promise.resolve({
    pageCount: 0,
    results: [],
    totalItems: 0,
    isTimeOut: false,
  })
}

/* eslint no-param-reassign: ["error", { "props": false }] */
export function LinkContratToUser(
  users: UserEntity[],
  contracts: ContractEntity[]
): UserEntity[] {
  const newusers = [...users]
  newusers.forEach((user) => {
    const entity = contracts.find((contract) => contract.id === user.contratId)
    user.contrat = entity
  })
  return newusers
}

// patch user status
export async function patchUserStatus(
  userstatus: string,
  userId: string
): Promise<number> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/users/${userId}`
  let status = 400
  try {
    const resp = await axios({
      method: 'PATCH',
      url,
      data: {
        state: userstatus,
      },
    })
    status = resp?.status
  } catch (err) {
    throw new Error(`Une erreur est survenue lors de l'enregistrement`)
  }
  return status
}

// patch user (generic)
export async function updateUserFields(
  userId: string,
  data: Partial<Record<string, unknown>>
): Promise<number> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/users/${userId}`
  let status = 400
  try {
    const resp = await axios({
      method: 'PATCH',
      url,
      data,
    })
    status = resp?.status
  } catch (err) {
    throw new Error(`Une erreur est survenue lors de l'enregistrement`)
  }
  return status
}

/**
 * Updates the application context using dispatch
 * This method is called in LoginForm, CheckUserForm and AutoRefreshToken
 */
export async function dispatchUserInformations(
  userInformations: any,
  dispatch: Dispatch<APP_ACTIONS>,
  state: InitialStateType
) {
  const {
    username,
    userId,
    isInternal,
    organizations,
    roleNames,
    firstname,
    backgroundColor,
    accessDemands,
    accessDocs,
    idContactWdh,
    isSuperAdminTech,
    service,
  } = userInformations

  // dispatch username & userId
  dispatch({
    type: ActionTypes.SET_TOKEN_INFO,
    payload: {
      username,
      userId,
      isInternal,
      organizations,
      roleNames,
      firstname,
      accessDemands,
      accessDocs,
      idContactWdh,
      isSuperAdminTech,
      service,
    },
  })

  if (backgroundColor) {
    dispatch({
      type: ActionTypes.SET_BACKGROUND_COLOR,
      payload: {
        backgroundColor,
      },
    })
  }

  if (state.allRoles.items.length === 0) {
    const allRoles = await getAllRoles()

    // dispatch all roles
    dispatch({
      type: ActionTypes.SET_ALL_ROLES,
      payload: {
        allRoles,
      },
    })
  }
}

export const getMSALToken = (email: string, force = false): Promise<any> => {
  const request = {
    scopes: [`${msalConfig.auth.clientId}/.default`],
    loginHint: email,
  }

  if (!force && msalInstance.getAccount() != null) {
    return msalInstance.acquireTokenSilent(request).catch((err) => {
      if (err.name === 'InteractionRequiredAuthError') {
        return getMSALToken(email, true)
      }

      return Promise.reject(err)
    })
  }

  msalInstance.loginRedirect(request)
  return msalInstance.acquireTokenSilent(request)
}

// resend creation mail
export async function sendCreationMail(userId: string): Promise<number> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/users/${userId}/send_creation_mail`
  let status = 400
  try {
    const resp = await axios({
      method: 'GET',
      url,
    })
    status = resp?.status
  } catch (err) {
    throw new Error(`Erreur lors de l'envoi du mail de création`)
  }
  return status
}

export async function updateUserPerimeter(
  userId: string,
  initialPerimeter: string[],
  finalPerimeter: string[],
  history: any,
  userStatut: string
): Promise<number> {
  const result = -1
  const organisationsToAdd = finalPerimeter.filter(
    (value: string) => !initialPerimeter.includes(value)
  )

  const organisationsToDelete = initialPerimeter.filter(
    (value: string) => !finalPerimeter.includes(value)
  )
  if (organisationsToAdd.length > 0) {
    const { entities } = await searchOrganizationByIds(
      organisationsToAdd,
      history,
      true
    )
    const data = getFormatedOrganisations(entities)
    await patchUserForPerimetreOrganisations(
      data.filter((item) => {
        return finalPerimeter.includes(item.organisationId)
      }),
      userId,
      history
    )
  }

  if (organisationsToDelete.length > 0) {
    const res = await searchOrganizationByIds(
      organisationsToDelete,
      history,
      true
    )
    const datas = getFormatedOrganisations(res.entities).filter((elem) => {
      return !finalPerimeter.includes(elem.organisationId)
    })
    await deleteOrganisationsForUser(
      datas.filter((item) => {
        return initialPerimeter.includes(item.organisationId)
      }),
      userId,
      history
    )
  }

  if (userStatut === 'beingCreated') {
    await patchUserForActivation('activated', userId, history)
  }
  return result
}

export async function impersonnate(username: string): Promise<UserData> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/impersonate`

  let impersonationToken = null

  try {
    const resp = await axios({
      method: 'POST',
      url,
      /* headers: {
        'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
      }, */
      data: qs.stringify({
        client_id: `${process.env.REACT_APP_CLIENT_ID}`,
        client_secret: `${process.env.REACT_APP_CLIENT_SECRET}`,
        grant_type: 'impersonation_grant',
        username,
      }),
    })

    // IMPERSONATION TOKEN
    impersonationToken = resp?.data?.impersonation_token

    // REFRESH TOKEN
    const refreshTokentmp = resp?.data?.refresh_token

    // Mise en place du refresh_token et impersonation_token dans sessionStorage
    const decodedToken: DecodedToken = jwt_decode(impersonationToken)
    sessionStorage.setItem('refresh_token', refreshTokentmp)
    sessionStorage.setItem('impersonation_token', impersonationToken)

    if (
      !decodedToken.username &&
      !decodedToken.user_id &&
      !decodedToken.organizations
    ) {
      return Promise.resolve({
        username: '',
        userId: '',
        isInternal: false,
        organizations: [],
        roleNames: [],
        firstname: '',
        accessDemands: false,
        accessDocs: false,
        idContactWdh: '',
        service: '',
        isSuperAdminTech: false,
      })
    }

    axios.defaults.headers.common = {
      Authorization: `Bearer ${impersonationToken}`,
    }

    const roles = decodedToken.roles.map((e) => e.name)

    return {
      username: decodedToken.username,
      userId: decodedToken.user_id,
      organizations: decodedToken.organizations.map((org) => org.id),
      roleNames: roles,
      firstname: decodedToken.first_name,
      accessDemands: Boolean(decodedToken.access_demands),
      accessDocs: Boolean(decodedToken.access_docs),
      isInternal: Boolean(decodedToken.isInternal),
      idContactWdh: decodedToken.id_contact_wdh,
      service: decodedToken.service,
      isSuperAdminTech: Boolean(decodedToken.is_super_admin_tech),
    }
  } catch (err) {
    throw new Error(err.response.data.message)
  }
}

export async function GenerateExcelUsers(usersData: any[]) {
  fetch('/resources/exportUtilisateurs.xlsx').then((response) => {
    response.arrayBuffer().then((buffer) => {
      const template = new XlsxTemplate(buffer)
      const expotedValues = {
        exportDate: moment(new Date()).format('DD/MM/YYYY'),
        exportedUser: usersData,
      }
      template.substitute(1, expotedValues)
      const result = template.generate({ type: 'arraybuffer' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(new Blob([result]))
      const day = moment(new Date()).format('YYYY_MM_DD')
      const filename = `Export_Utilisateurs_${day}.xlsx`
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    })
  })
}

export async function exportUsers(
  maxTotalLimit: number,
  allRoles: AllRolesEntity[]
): Promise<boolean> {
  try {
    let users: any[] = []
    let currentUrl = `${process.env.REACT_APP_BASE_API_URL}/users/export?perPage=${maxTotalLimit}&page=1`
    let hasMorePage = true

    while (hasMorePage) {
      const resp = await axios({
        method: 'GET',
        url: currentUrl,
      })

      const totalItems = parseInt(resp.data['hydra:totalItems'], 10)
      const entities = getMemberData(resp?.data)
      users = [...users, ...entities]
      if (totalItems > users.length) {
        hasMorePage = !isLastPage(resp.data)
        currentUrl = `${process.env.REACT_APP_BASE_API_URL}${getNextPage(
          resp.data
        )}`
      } else {
        hasMorePage = false
      }
    }
    const dataToExport: any[] = users.map((user: any) => ({
      firstname: user.firstname,
      lastname: user.lastname,
      username: user.username,
      domain: getDomainMail(user.username),
      createdAt: user.createdAt ? parseDate(user.createdAt) : '',
      lastConnexionDate: user.lastConnexionDate
        ? parseDate(user.lastConnexionDate)
        : '',
      role: getAdminUserSymbol(user.roles, allRoles, true),
      state: getStatusValue(user.state, StatusOptions),
      type: user.type === 'internal' ? 'Interne' : 'Externe',
      accessDocs: user.accessDocs ? 'Oui' : 'Non',
      accessDemands: user.accessDemands ? 'Oui' : 'Non',
      injectionCode: user.injectionCode || '',
      createdBy: user.createdByEmail || '',
      canal: user.canal || '',
    }))

    await GenerateExcelUsers(dataToExport)
    return true
  } catch (err) {
    throw new Error(`Erreur : ${err}`)
  }
}
